import * as types from './mutation_types'
import getters from './getters'

export default {
  [types.UPDATE_CATEGORIES] (state, payload) {
    state.categories = payload
  },
  [types.UPDATE_LATEST_POSTS] (state, payload) {
    state.latestPosts = payload
  },
  [types.UPDATE_CATE_POSTS] (state, payload) {
    const data = getters.cloneData(state.catePosts)
    data[payload.key] = payload.value
    state.catePosts = data
  },
  [types.UPDATE_CURRENT_CATE] (state, payload) {
    state.currentCate = payload
  },
  [types.UPDATE_TAG_POSTS] (state, payload) {
    const data = getters.cloneData(state.tagPosts)
    data[payload.key] = payload.value
    state.tagPosts = data
  },
  [types.UPDATE_EDITOR_POSTS] (state, payload) {
    const data = getters.cloneData(state.editorPosts)
    data[payload.key] = payload.value
    state.editorPosts = data
  },
  [types.UPDATE_CURRENT_EDITOR] (state, payload) {
    state.currentEditor = payload
  },
  [types.UPDATE_SEARCH_ARTICLES] (state, payload) {
    const data = getters.cloneData(state.searchArticles)
    data[payload.key] = payload.value
    state.searchArticles = data
  },
  [types.UPDATE_SEARCH_GALLERIES] (state, payload) {
    const data = getters.cloneData(state.searchGalleries)
    data[payload.key] = payload.value
    state.searchGalleries = data
  },
  [types.UPDATE_REGION_COUNTRIES] (state, payload) {
    state.regionCountries = payload
  },
  [types.UPDATE_BRANDS] (state, payload) {
    state.brands = payload
  },
  [types.UPDATE_TOURNAMENTS] (state, payload) {
    const data = getters.cloneData(state.tournaments)
    data[payload.key] = payload.value
    state.tournaments = data
  },
  [types.UPDATE_UPCOMING_TOURNAMENTS] (state, payload) {
    state.upcomingTournaments = payload
  },
  [types.UPDATE_EVENTS] (state, payload) {
    const data = getters.cloneData(state.events)
    data[payload.key] = payload.value
    state.events = data
  },
  [types.UPDATE_DATE_PERIOD] (state, payload) {
    state.datePeriod = payload
  },
  [types.UPDATE_FEEDS] (state, payload) {
    state.feeds = payload
  },
  [types.UPDATE_SERIES] (state, payload) {
    state.series = payload
  },
  [types.UPDATE_ALBUMS] (state, payload) {
    state.albums = payload
  },
  [types.UPDATE_ALBUM_IMAGES] (state, payload) {
    state.albumImages = payload
  },

  [types.PUSH_LIST_OF_CALLED_API] (state, payload) {
    const index = state.listOfCalledAPI.indexOf(payload)
    if (index < 0) state.listOfCalledAPI.push(payload)
  },
  [types.UPDATE_DISPLAY_CATE_DATA] (state, payload) {
    state.displayCateData = payload
  },
  [types.UPDATE_DISPLAY_DATA] (state, payload) {
    if (payload.length > 0) {
      state.displayData = state.displayData.concat(payload)
      state.isUpdatedDisplayData = true
      setTimeout(() => state.isUpdatedDisplayData = false)
    }
  },
  [types.UPDATE_DISPLAY_PAGE] (state, payload) {
    if (!state.displayPage.includes(payload)) state.displayPage.push(payload)
  },

  [types.CHANGE_SIZE_TOAST_BANNER] (state, payload) {
    state.smallToastBanner = payload
  },
  [types.CHANGE_OPEN_SHARE_DIALOG] (state, payload) {
    state.openShareDialog = payload
  },
	[types.CHANGE_OPEN_FOOTER1_DIALOG] (state, payload) {
    state.openFooter1Dialog = payload
  },
	[types.CHANGE_OPEN_FOOTER2_DIALOG] (state, payload) {
    state.openFooter2Dialog = payload
  },
	[types.CHANGE_OPEN_FOOTER3_DIALOG] (state, payload) {
    state.openFooter3Dialog = payload
  },
	[types.CHANGE_OPEN_FAQ_DIALOG] (state, payload) {
    state.openFaqDialog = payload
  },
	[types.CHANGE_OPEN_TEAM_DIALOG] (state, payload) {
    state.openTeamDialog = payload
  },
	[types.UPDATE_OPEN_DROPDOWN] (state, payload) {
    state.openTeamDropdown = payload
  },
  [types.UPDATE_CURRENT_CONTENTS_DATA] (state, payload) {
    state.currentContentsData = payload
  },
}
